import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Test } from '../dto/test';
import { BoolDto } from '../../../common/dto/bool-dto';

@Injectable({
  providedIn: 'root'
})
export class TestService {
  private apiUrl = environment.apiRoot + '/test';

  constructor(private http: HttpClient) { }

  getAllTestsOfTrail(trailId: number): Observable<Test[]> {
    return this.http.get<Test[]>(this.apiUrl + '/alloftrail?trailId=' + trailId);
  }

  createTest(trailId: number): Observable<Test> {
    let model = { "id": 0, "trail_id": trailId, "sn": "#", "name": "new test" };
    return this.http.post<Test>(this.apiUrl + '/new', model);
  }

  updateTest(model: Test): Observable<Test> {
    return this.http.put<Test>(this.apiUrl + '/update', model);
  }

  deleteTest(testId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?testId=' + testId);
  }

  //--- for selections of binary states ---

  getAllTestBinaryStates(): BoolDto[] {
    let states = [
      { state: true, expression: 'Yes' },
      { state: false, expression: 'No' },
    ]
    return states;
  }

  getTestBinaryState(list: BoolDto[], state?: boolean): BoolDto {
    for (let element of list) {
      if (state === element.state) {
        return element;
      }
    }
    return { state: false, expression: 'N/A' };
  }
}
